import React, { useState, useEffect } from 'react';
import './styles.css';

const SimpleCarousel = ({
  images = [],
  autoPlay = false,
  interval = 3000,
  showDots = true,
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const total = images.length;

  useEffect(() => {
    if (!autoPlay) return;
    const timer = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % total);
    }, interval);
    return () => clearInterval(timer);
  }, [autoPlay, interval, total]);

  const goToSlide = (index) => {
    setCurrentIndex((index + total) % total);
  };

  return (
    <div className="carousel">
      <button className="nav-button prev" onClick={() => goToSlide(currentIndex - 1)}>&#10094;</button>
      <button className="nav-button next" onClick={() => goToSlide(currentIndex + 1)}>&#10095;</button>

      <div className="carousel-window">
        <div
          className="carousel-track"
          style={{
            transform: `translateX(-${currentIndex * 35}%)`,
            width: `${images.length * 100}%`,
          }}
        >
          {images.map((src, i) => (
            <img key={i} src={src} alt={`Slide ${i}`} className="carousel-image" />
          ))}
        </div>
      </div>

      {showDots && (
        <div className="carousel-dots">
          {images.map((_, i) => (
            <span
              key={i}
              className={i === currentIndex ? 'active' : ''}
              onClick={() => goToSlide(i)}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default SimpleCarousel;
